<template>
<div v-clickoutside="changeShow" class="cont-right-one select-box" id="ftpContRight" :class="selectBoxClass" @click="selectShowFunction" @click.stop="showData()" ref="sel">
    <div>
        <span>{{currentValue}}</span>
        <div class="icon-util" :class="dropDownName" style="float: right;"></div>
    </div>
    <div class="select-value" v-show="selectShow&&selectOption.length" id="selectValue" ref="selectValueWidth">
        <div class="select-value-option" :key=index @click="changSelectValue($event,index)" v-for="(item,index) in selectLength">
            {{item.name}}
            <div v-if="item.icon==true" class="icon-util vip select-vip-position"></div>
        </div>
    </div>
</div>
</template>

<script>
import commonstate from '@/js/constant.js';
export default {
    data: function () {
        return {
            selectShow: false,
            selectBoxClass: '',
            dropDownName: 'drop-down',
            currentValue: this.placeholder,
            selectLength: this.selectOption,
            maxValue: 0,
            listNormalOpen:false
        }
    },
    watch: {
        currentValue(newName, oldName) {
            this.$emit('changeOption', newName);
        },
        selectOption(newName, oldName){
            this.selectLength =newName;
        }
    },
    props: {
        selectOption: {
            type: Array,
            default () {
                return []
            }
        },
        placeholder: {
            type: String
        },
        widthVal: {
            type: null
        },
       
    },
    mounted() {
        this.setInputWidth();
    },
    methods: {
        showData(){
            this.selectShow=!this.selectShow;
        },
        selectShowFunction() { //选中选项时控制下拉框的
            let lengthItem = [];
            if (this.selectShow) {
                this.selectBoxClass = '';
                this.dropDownName = 'drop-down';
            } else {
                this.selectBoxClass = 'select-box-click';
                this.dropDownName = 'drop-down-up';
            }
           
            $.each(this.selectOption, function (index, item) {
                lengthItem.push(item.name.length);
            });
            let maxNumber = Math.max(...lengthItem);
            if (this.maxValue < maxNumber) {
                this.maxValue = maxNumber;
                this.setInputWidth();
            }else{
                this.setInputWidth();
            }
        },
        setInputWidth() {
            let that=this;
            let mainLength = this.$refs.sel; //选中选项的长度
            let selectLength = this.$refs.selectValueWidth; //下边未选中选项的长度
            let lengthItem = [];
            $.each(this.selectOption, function (index, item) {
                if(index==0){
                    lengthItem.push(that.currentValue.length);
                }
                lengthItem.push(item.name.length);
            });
            let maxNumber = Math.max(...lengthItem);
            if (selectLength) {
                if ( this.$i18n.locale == 'japanese' || this.$i18n.locale == 'traditionalChinese' || this.$i18n.locale == 'chinese') {
                    mainLength.style.width = maxNumber * 17 + 'Px'; //将最大长度长设为其宽度
                } else if(this.$i18n.locale == 'spanish'){
                    mainLength.style.width = maxNumber * 9 + 'Px'; //将最大长度长设为其宽度
                    // if(mainLength.innerText=='Sincronización en tiempo real'){
                    //  mainLength.style.width = maxNumber * 11 + 'Px';    
                    // }
                }else if(this.$i18n.locale == 'italian'){
                   mainLength.style.width = maxNumber * 8 + 'Px';
                } else if(this.$i18n.locale == 'portuguese'){
                     mainLength.style.width = maxNumber * 9 + 'Px'; //将最大长度长设为其宽度
                } else if(this.$i18n.locale == 'deutsch'){
                     mainLength.style.width = maxNumber * 10 + 'Px'; //将最大长度长设为其宽度
                } else if(this.$i18n.locale == 'france'){
                     mainLength.style.width = maxNumber * 9.5 + 'Px'; //将最大长度长设为其宽度
                } else if(this.$i18n.locale == 'nederlands'){
                    mainLength.style.width = maxNumber * 8 + 'Px'; //将最大长度长设为其宽度
                }else {
                    mainLength.style.width = maxNumber * 9 + 'Px'; //将最大长度长设为其宽度
                }
                selectLength.style.width = mainLength.clientWidth + 'Px';
                selectLength.style.height = (this.selectOption.length) * 34 + 'Px';
            }
        },
        sortNumber(a, b) {
            return b - a
        },
        //用户点击一个选项
        changSelectValue(event, index) {
            // if(event.currentTarget.innerText== this.$t('language.cloudSync.twoWay')){
            //     return;
            // }
            if(event.currentTarget.innerText== this.$t('language.cloudSync.realTimeSync') && this.$parent.listNormalOpen){
                this.$toast({
                     text: this.$t('language.exception.notSupported'),
                     type: 'notice',
                     idValue: "rightContBan"
                     });
              return false;
            }
            //  if(event.currentTarget.innerText=='Sincronización en tiempo real'){
            //           this.$refs.sel.style.width = 21 * 11 + 'Px';    
            //  }
            this.currentValue = event.currentTarget.innerText;
            this.selectShowFunction();
            this.$emit('deleteSelectOption', index);
        },
        changeShow() {
            this.selectShow = false;
            this.selectBoxClass = '';
            this.dropDownName = 'drop-down';
        }
    }
}
</script>

<style scoped>
/*设置下拉框样式*/
.select-box {
    height: 34px;
    /*no*/
    border: 1px solid #E0EAF9;
    /*no*/
    outline: none;
    margin-top: 10px;
    /*no*/
    box-sizing: border-box;
    background-color: transparent;
    padding-left: 10px;
    /*no*/
    line-height: 34px;
    /*no*/
    font-size: 14px;
    /*no*/
    margin-left: 10px;
    /*no*/
    background: #FFF;
}

.select-box-click {
    border: 1px solid #8A96E3;
    /*no*/
}

.select-value {
    position: absolute;
    z-index: 300;
    font-size: 14px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    border: 1px solid #8A96E3;
    /*no*/
    border-top: none;
    background: #FFF;
    left: -1px;
    /*no*/
    top: 33px;
    /*no*/
}

.select-value-option {
    width: 100%;
    height: 33px;
    /*no*/
    line-height: 34px;
    /*no*/
    padding: 0px 10px 0px 10px;
    /*no*/
    box-sizing: border-box;
    white-space: nowrap;
     cursor: pointer;
}

.select-value-option:hover {
    background-color: #EBF3FE;

}

.select-vip-position {
    position: relative;
    top: 26%;
    float: right;
}

.cont-right-one {
    min-width: 200px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    margin-left: 10px;
    /*no*/
    float: left;
    position: relative;
}

#ftpContRight {
    white-space: nowrap;
    max-width: 600px !important;
    /*no*/
}

#selectValue {
    max-width: 600px !important;
    /*no*/
}
.select-none-div{
    width: 100%;
    height: 34px;
    /*no*/
    line-height: 34px;
    /*no*/
    padding: 0px 10px 0px 10px;
    /*no*/
    box-sizing: border-box;
    white-space: nowrap;
    cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/components/common/select/cloud_select.vue